export const corteMoraKeys = {
  all: ['reportes', 'corte-mora'] as const,
  lists: () => [...corteMoraKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...corteMoraKeys.lists(), filters] as const,
  stats: (filters: Record<string, unknown>) => [...corteMoraKeys.all, 'stats', filters] as const,
};
